import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingOverlay } from '@mantine/core';
import './shared/AuthStyles.css';
import './MantineLoginPage.css';
import { signIn } from 'aws-amplify/auth';
import PasswordRequirementInput from './common/PasswordRequirementInput';

import {
  TextInput,
  PasswordInput,
  Checkbox,
  Button,
  Paper,
  Container,
  Stack,
  Text
} from '@mantine/core';


function MantineLoginPage({ onPageChange }) {
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation()
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    keepSignedIn: false,
    type: 'login'
  });

  const [formErrors, setFormErrors] = useState({
    email: '',
    password: '',
    auth: '' // For whatever Amplify Auth returns
  });

  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear email error if valid email is entered
    if (field === 'email' && validateEmail(value)) {
      setFormErrors(prev => ({
        ...prev,
        email: ''
      }));
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!validateEmail(formData.email)) {
      setFormErrors(prev => ({
        ...prev,
        email: 'Invalid email address'
      }));
      setIsLoading(false);
      return;
    }

    try {
      const signInResponse = await signIn({ 
        username: formData.email,
        password: formData.password
      });

      if (signInResponse.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        // Redirect to change password page with challenge response
        navigate('/change-password', { 
          state: { challengeResponse: signInResponse }
        });
      } else if (signInResponse.isSignedIn) {
        setIsLoading(false);
        onPageChange('admin/calendar');
      }
    } catch (error) {
      console.error('Error signing in:', error);
      setIsLoading(false);
      setFormErrors(prev => ({
        ...prev,
        password: error.message,
        auth: error.message
      }));
    }
  };

  return (
    <div>
      {isLoading && <LoadingOverlay visible={true} overlayBlur={2} />}
      <div className="auth-container">
          <div className="auth-tabs">
          <button 
              className="auth-tab"
              onClick={() => onPageChange('signup')}
          >
              Sign up
          </button>
          <button 
              className="auth-tab active"
              onClick={() => onPageChange('login')}
          >
              Log in
          </button>
          </div>
      </div>
      <Container size="xs" mt="xl" py="md">
        <Paper py="xl">
          {state?.successMessage && <Text size="sm" ta="center" mb="xl" c="green">{state.successMessage}</Text>}
          {formErrors.auth && <Text size="md" ta="center" mb="xl" c="red">{formErrors.auth}</Text>}
          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput
                label="Email address"
                placeholder="Enter your email"
                value={formData.email}
                onChange={(event) => handleInputChange('email', event.currentTarget.value)}
                size="md"
                radius="md"
                required
                error={formErrors.email}
              />

              <PasswordRequirementInput
                value={formData.password}
                onChange={(event) => handleInputChange('password', event.currentTarget.value)}
                size="md"
                radius="md"
                required
                showRequirements={false}
              />

              <Checkbox
                label="Keep me signed in"
                checked={formData.keepSignedIn}
                onChange={(event) => handleInputChange('keepSignedIn', event.currentTarget.checked)}
                size="md"
                required={false}
              />

              <Stack gap="xs">
                <Button
                  type="submit"
                  fullWidth
                  size="md"
                  radius="xl"
                  variant="filled"
                >
                  Log In
                </Button>

                <Button 
                  onClick={() => onPageChange('forgot-password')} 
                  size="sm" 
                  variant="transparent"
                  c="dimmed" 
                  td="underline"
                >
                  Forgot your password
                </Button>
              </Stack>
            </Stack>
          </form>
        </Paper>
      </Container>
    </div>
  );
}

export default MantineLoginPage; 